import { Fragment, useState } from "react";
import { useCart } from "@ludens-reklame/rubics-v3-react/cart/hooks";
import { transformImageUrl } from "@ludens-reklame/rubics-v3-sdk/file/utils";
import {
  Card,
  CartItems,
  CounterWrapper,
  DiscountCode,
  Grid,
  ProductImage,
  Remove,
  Table,
  Title,
  ToCheckout,
  Wrapper,
} from "./styles.js";
import {
  Constrainer,
  HorizontalSpacer,
} from "../../internal-components/Layout.js";
import { Counter } from "../../internal-components/Counter.js";
import { formatCurrency } from "../../util/formatter.js";
import { DefinitionList } from "../../internal-components/DefinitionList.js";
import { Ruler } from "../../internal-components/product/Ruler.js";
import { Button } from "../../internal-components/Button.js";
import { destroy } from "../../icons/index.js";

export const Cart: React.FC = () => {
  const [discountCode, setDiscountCode] = useState<string>("");
  const cartInterface = useCart();

  return (
    <Wrapper>
      <HorizontalSpacer>
        <Constrainer>
          <Title className="h5">Din handlekurv</Title>
          <Grid>
            <div>
              <Card $transparentOnMobile>
                <CartItems>
                  {cartInterface.cart.items.map((i) => (
                    <li key={i._id}>
                      <Remove
                        href="#"
                        aria-label={`Fjern ${i.product.name} fra handlekurven`}
                        onClick={(e) => {
                          e.preventDefault();
                          cartInterface.removeItems([i._id]);
                        }}
                      >
                        {destroy}
                      </Remove>
                      {i.product.primaryImage && (
                        <ProductImage
                          src={transformImageUrl(i.product.primaryImage, {
                            width: 460,
                            height: 460,
                            fit: "contain",
                          })}
                          alt={i.product.primaryImage.url}
                        />
                      )}
                      <div>
                        <h2 className="h4">{i.product.name}</h2>
                        <Ruler $tighterOnMobile />
                        {i.attributes.length > 0 && (
                          <DefinitionList $horizontal>
                            {i.attributes.map((a) => (
                              <Fragment key={a._id}>
                                <dt>{a.name}</dt>
                                <dd>{a.value}</dd>
                              </Fragment>
                            ))}
                          </DefinitionList>
                        )}
                        <CounterWrapper>
                          <Counter
                            disabled={cartInterface.networking}
                            value={i.quantity}
                            onChange={(value) =>
                              cartInterface.updateItem(i._id, {
                                quantity: value,
                              })
                            }
                          />
                        </CounterWrapper>
                        <p className="h5">Total: {i.totalText}</p>
                      </div>
                    </li>
                  ))}
                </CartItems>
                <DiscountCode
                  onSubmit={async (e) => {
                    e.preventDefault();
                    await cartInterface.update({
                      discountCodes: [
                        ...cartInterface.cart.discountCodes,
                        discountCode,
                      ],
                    });
                    setDiscountCode("");
                  }}
                >
                  <label htmlFor="discountCode" className="h4">
                    Har du en rabattkode?
                  </label>
                  <div>
                    <input
                      id="discountCode"
                      value={discountCode}
                      placeholder="Din rabattkode..."
                      onChange={(e) => setDiscountCode(e.target.value)}
                    />
                    <Button
                      type="submit"
                      disabled={cartInterface.networking}
                      $variant="secondary"
                    >
                      Aktiver rabattkode
                    </Button>
                  </div>
                </DiscountCode>
              </Card>
            </div>
            <div>
              <Card>
                <h2 className="h4">Bestillingsoversikt</h2>
                <Table>
                  <tbody>
                    <tr>
                      <td>Eks. MVA</td>
                      <td>
                        {formatCurrency(
                          cartInterface.cart.total +
                            cartInterface.cart.totalDiscount
                        )}
                      </td>
                    </tr>
                    {cartInterface.cart.discountLines.map((d) => (
                      <tr key={d._id}>
                        <td>
                          {d.code || d.name}
                          {d.code && (
                            <button
                              disabled={cartInterface.networking}
                              onClick={() => {
                                cartInterface.update({
                                  discountCodes:
                                    cartInterface.cart.discountCodes.filter(
                                      (c) => c !== d.code
                                    ),
                                });
                              }}
                            >
                              fjern
                            </button>
                          )}
                        </td>
                        <td>-{d.totalText}</td>
                      </tr>
                    ))}
                  </tbody>
                  <tfoot>
                    <tr>
                      <td>Inkl. MVA</td>
                      <td>{cartInterface.cart.totalText}</td>
                    </tr>
                  </tfoot>
                </Table>
                <ToCheckout>
                  <Button as="a" href="/utsjekk">
                    Gå til kassa
                  </Button>
                </ToCheckout>
              </Card>
            </div>
          </Grid>
        </Constrainer>
      </HorizontalSpacer>
    </Wrapper>
  );
};
